import React from 'react'
import PropTypes from 'prop-types'
import './how-decided.scss'
import boxIcon from './../../img/decide-box.svg'
import clockIcon from './../../img/decide-clock.svg'
import interviewIcon from './../../img/decide-interview.svg'

export default class HowDecided extends React.Component {
  render() {
    const { data } = this.props;
    const res = data.reduce(function (map, string) {
      const key = string.split(':')[0]
      const value = string.split(':')[1]
      map[key] = value;
      return map;
    }, {});

    return (
      <div className="how-decided">
        <section className="how-decided__wrapper">
          <h3 className="how-decided__title">
            How I decided
          </h3>
          <div className="how-decided__icons">
            <div className="how-decided__icon-item">
              <img className="how-decided__img" src={boxIcon} width="40" height="40" alt="box-icon" />
              <div className="how-decided__num">{res.considered}</div>
              <div className="how-decided__label">models considered</div>
            </div>
            <div className="how-decided__icon-item">
              <img className="how-decided__img" src={clockIcon} width="40" height="40" alt="clock-icon" />
              <div className="how-decided__num">{res.hours}</div>
              <div className="how-decided__label">hours spend</div>
            </div>
            <div className="how-decided__icon-item">
              <img className="how-decided__img" src={interviewIcon} width="40" height="40" alt="interview-icon" />
              <div className="how-decided__num">{res.interviewed}</div>
              <div className="how-decided__label">experts interviewed</div>
            </div>

          </div>
        </section>
      </div>
    )
  }
}

HowDecided.propTypes = {
  data: PropTypes.array,
}



// WEBPACK FOOTER //
// ./src/components/how-decided/how-decided.js